/** Normalize theme color fields from Redux theme payload. */
export function resolveThemeColors(themeData) {
  if (!themeData || typeof themeData !== 'object') return {};

  let colors = themeData.colors;
  if (typeof colors === 'string') {
    try {
      colors = JSON.parse(colors);
    } catch {
      colors = null;
    }
  }

  if (colors && typeof colors === 'object') {
    return colors;
  }

  return {};
}

/** Inline styles for primary action buttons (Play Again, lobby CTAs, etc.). */
export function buildThemeActionButtonStyle(themeData) {
  const colors = resolveThemeColors(themeData);
  const bg = String(colors.option_color ?? '').trim();
  const fg = String(colors.option_text_color ?? '').trim();

  return {
    backgroundColor: bg || 'var(--option-color)',
    color: fg || 'var(--option-text-color)',
  };
}

/** Sync :root CSS variables when theme loads (matches dddUI/user.jsx). */
export function applyThemeCssVariables(themeData) {
  const colors = resolveThemeColors(themeData);
  if (!colors) return;

  const root = document.documentElement.style;
  if (colors.text_color) root.setProperty('--text-color', colors.text_color);
  if (colors.ui_color_1) root.setProperty('--ui-color-1', colors.ui_color_1);
  if (colors.ui_color_2) root.setProperty('--ui-color-2', colors.ui_color_2);
  if (colors.option_color) root.setProperty('--option-color', colors.option_color);
  if (colors.option_text_color) {
    root.setProperty('--option-text-color', colors.option_text_color);
  }
}
